/* Libraries */
require('angular');
require('angular-ui-router');
require('angular-animate');
require('angular-cookies');
require('angular-resource');
require('angular-translate');
require('angular-translate/dist/angular-translate-storage-local/angular-translate-storage-local.js');
require('angular-paging');
require('angularjs-datepicker/src/js/angular-datepicker.js');
require('angularjs-datepicker/dist/angular-datepicker.min.css');
require('angular-toastr');
require('angular-scroll');
require('angular-sanitize');
require('angular-moment');
require('angular-toastr/dist/angular-toastr.min.css');
require('font-awesome/css/font-awesome.min.css');
require('angular-loading-bar');
require('angular-loading-bar/build/loading-bar.min.css');
require('lodash');
require('moment');
require('moment-timezone');

/* Project files */
require('./app.scss');
require('./app.js');
require('./index.html');

/* Modules */

/* Components */
require('./components');

	/* Private */
require('./private');

	/* Public */
require('./public');




/** WEBPACK FOOTER **
 ** ./client/entry.js
 **/